import { IStyle } from 'Styles';
import { CustomCheckBox } from 'components/input';
import React from 'react';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import { setSelectedIngredientList } from 'redux/reducers/experimentReducer';
import { selectExp } from 'redux/selectors/ExperimentStateSelector';

export interface WellIngredientsProps {
  allWellIngsList: string[];
  selectedIngredients: string[];
  lastActionPerformed: {};
  setSelectedIngredients: React.Dispatch<React.SetStateAction<string[]>>;
  ingredientsSelection: () => void;
}
const WellIngredients = (props) => {
  const {
    allWellIngsList,
    selectedIngredients,
    lastActionPerformed,
    setSelectedIngredients,
    ingredientsSelection,
  } = props;
  const experimentData = useRMSelector(selectExp);
  const dispatch = useRMDispatch();
  const ingredientsList = allWellIngsList.map((ing, i) => (
    <div id='exp-welling-section' key={`ingg${ing?.id || i}`} style={styles.ingredientsSection}>
      <CustomCheckBox
        id='exp-welling-checkbox'
        onChange={() => changeIngredientsSelectedItems(ing)}
        label={ing}
        checked={selectedIngredients.includes(ing)}
        labelStyle={{ fontFamily: 'Arial', fontWeight: 400, marginLeft: '0.75rem' }}
      />
    </div>
  ));

  const changeIngredientsSelectedItems = (ing) => {
    const newSelectedIngredientsList = [...selectedIngredients];
    if (newSelectedIngredientsList.includes(ing)) {
      newSelectedIngredientsList.remove(ing);
    } else {
      newSelectedIngredientsList.push(ing);
    }
    ingredientsSelection(
      lastActionPerformed.ings,
      newSelectedIngredientsList,
      experimentData.plateDto,
    );
    setSelectedIngredients(newSelectedIngredientsList);
    dispatch(setSelectedIngredientList(newSelectedIngredientsList));
  };

  return <>{ingredientsList}</>;
};

export const styles: IStyle = {
  ingredientsSection: {
    marginTop: '2%',
    marginLeft: '5%',
  },
};

export default WellIngredients;
